// @flow

import styled from '@emotion/styled'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import * as text from '../text'

type Props = {|
  image:
    | React.Element<'img'>
    | React.Element<typeof GatsbyImage>
    | React.Element<typeof StaticImage>,
  title: string,
  paragraph: string | React.Node,
|}

export function FeatureIcon({ image, title, paragraph }: Props) {
  return (
    <Root>
      {image}
      <Title color={colors.darkPurple}>{title}</Title>
      <text.P3 color={colors.fadedPurpleAlt}>{paragraph}</text.P3>
    </Root>
  )
}

const Root: React.ComponentType<any> = styled.div`
  margin-bottom: 30px;
  img {
    height: 100px;
    object-fit: contain;
  }
  ${media.mq[1]} {
    flex: 1;
  }
  ${media.mq[2]} {
    padding-right: 30px;
    img {
      margin-bottom: 10px;
      height: 140px;
    }
  }
`

const Title = styled(text.H5)`
  margin: 15px 0 10px;
  line-height: 1.2;
`
